import { useQuery, type UseQueryOptions } from '@tanstack/react-query'

import { getAllBusinessCategories } from '@flecto/api/shared'
import { type CoreBusinessCategory } from '@flecto/types'

export function useQueryGetBusinessCategories(
  options?: UseQueryOptions<CoreBusinessCategory[]>
) {
  return useQuery({
    queryKey: ['business_categories'],
    queryFn: async () => await getAllBusinessCategories(),
    refetchOnWindowFocus: false,
    ...(options || {}),
  })
}
